import { apiHost } from "../../../../consts";

import type { SocialToggleKind } from "./SocialToggle.types";

export type SocialKindConfig = {
  url: string;
  symbol: string;
  countKey: string;
  toggledKey: string;
  oppositeKind?: SocialToggleKind;
};

export const kindConfig: Record<SocialToggleKind, SocialKindConfig> = {
  like: {
    url: `${apiHost}/solutions/api/likes/`,
    symbol: "👍",
    countKey: "likeCount",
    toggledKey: "likedByUser",
    oppositeKind: "dislike",
  },
  dislike: {
    url: `${apiHost}/solutions/api/dislikes/`,
    symbol: "👎",
    countKey: "dislikeCount",
    toggledKey: "dislikedByUser",
    oppositeKind: "like",
  },
  favorite: {
    url: `${apiHost}/solutions/api/favorites/`,
    symbol: "⭐",
    countKey: "favoriteCount",
    toggledKey: "favoritedByUser",
  },
  review: {
    url: `${apiHost}/solutions/api/reviews/`,
    symbol: "✅ ",
    countKey: "reviewCount",
    toggledKey: "reviewedByUser",
  },
};
